"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const Button = styled_components_1.default.button `
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.14px;
  height: 42px;
  border-radius: 5px;
  padding: 16px;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
  display: flex;
  border: 1px solid ${colors_1.gray200};
  background-color: transparent;
  cursor: pointer;
`;
exports.Button = Button;
